// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"style_loadingContainer__2rTN3","loadingMessage":"style_loadingMessage__gC894"};